import { useTranslation } from 'react-i18next'

import ClearCartModal from '@features/cart/ui/clear-cart/modal'
import styles from '@features/cart/ui/modal/styles.module.scss'
import { useModalStore } from '@features/modal'


export default function useClearCartModal () {
  const { openModal, closeModal } = useModalStore()
  const { t: tc } = useTranslation('cart')

  return {
    openClearCartModal: () =>
      openModal('clearCart', <ClearCartModal />, {
        classes: {
          content: styles['modal-content'],
        },
        title: tc('clear.title'),
        description: tc('clear.desc'),
      }),
    closeClearCartModal: () => closeModal('clearCart'),
  }
}
